import styled from 'styled-components';

import LoadingWrapper from '../../../../../CoreWrappers/LoadingWrapper';

export default styled(LoadingWrapper)`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: var(--min-height);
	max-height: var(--max-height);
	padding: var(--gap);
	gap: var(--gap);
	position: relative;

	.controls-hr {
		margin-top: auto;
	}

	.controls {
		display: flex;
		gap: var(--spacing-small);
	}

	&.empty {
		min-height: unset;
	}
`;
